export default import.meta.ROLLDOWN_FILE_URL_hYL7Rtl8BrtKh60VrtjM$A